export const RequirementRuleTypes = {
    atLeastOneProvided: 'atLeastOneProvided',
    atLeastOneMapped: 'atLeastOneMapped',
    leaveEmptyToSkip: 'leaveEmptyToSkip',
};

/**
 * Requirement rules keyed by catalog meta key (see getCatalogMetaKey).
 * @type {Record<string, Array<{type: string, id: string, fieldNames: string[], messageKey: string, uiVariant?: string}>>}
 */
export const DATASET_REQUIREMENT_RULES = {
    partVisibility: [{
        type: RequirementRuleTypes.atLeastOneProvided,
        id: 'visibility-target',
        fieldNames: ['isVisible', 'isVisibleForClient'],
        messageKey: 'rules.visibilityAtLeastOne',
        uiVariant: 'or-connector',
    }],
    partTechnicalInformation: [{
        type: RequirementRuleTypes.atLeastOneMapped,
        id: 'technical-properties',
        fieldNames: [],
        messageKey: 'rules.technicalAtLeastOneMapped',
        uiVariant: 'info',
    }],
    productCodeAssignment: [{
        type: RequirementRuleTypes.atLeastOneMapped,
        id: 'code-groups',
        fieldNames: [],
        messageKey: 'rules.productCodeAtLeastOneGroup',
        uiVariant: 'info',
    }],
    partPriceLevels: [
        {
            type: RequirementRuleTypes.atLeastOneMapped,
            id: 'price-levels',
            fieldNames: [],
            messageKey: 'rules.partPriceAtLeastOneMapped',
            uiVariant: 'info',
        },
        {
            type: RequirementRuleTypes.leaveEmptyToSkip,
            id: 'price-null-skip',
            fieldNames: [],
            messageKey: 'rules.partPriceLeaveEmpty',
            uiVariant: 'info',
        },
    ],
};

/**
 * Alert keys shown in catalog expanded view and dropzone.
 * @type {Record<string, string[]>}
 */
export const DATASET_ALERT_KEYS = {
    partPriceLevels: ['alerts.partPriceNull'],
    productDimensions: ['alerts.productDimensionsUnits'],
    productVendors: ['alerts.productVendorsConflict'],
    priceMatrices: ['alerts.priceMatricesDates'],
    productCodeAssignment: ['alerts.productCodeGroups'],
    partTechnicalInformation: ['alerts.technicalOptionalColumns'],
    productCodeAssignmentNoGroups: ['alerts.noCodeGroups'],
    removeProduct: ['alerts.removeProductDanger'],
    setInventoryAvailability: [{
        key: 'alerts.setInventoryAvailabilityDanger',
        severity: 'warning',
    }],
};

/**
 * @param {string} dataSourceId
 * @returns {string}
 */
export const getCatalogMetaKey = (dataSourceId) => dataSourceId ?? '';

/**
 * @param {string} fieldName
 * @returns {string}
 */
export const getColumnMetaKey = (fieldName) => {
    if (fieldName === 'partNumber' || fieldName === 'partNo') return 'partNumber';
    if (fieldName.startsWith('priceLevel_')) return 'priceLevel';
    if (fieldName.startsWith('property_')) return 'property';
    if (fieldName.startsWith('codeGroup_')) return 'codeGroup';
    if (fieldName.startsWith('warehouse_')) return 'warehouse';
    return fieldName;
};
